import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const items = [['¿Cómo recibo el Mega Pack después de comprar?', 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes.'], ['¿Para qué nivel educativo está pensado?', 'Para docentes de historia de nivel secundario, medio superior, institutos y academias. El material es adaptable a distintos niveles y ritmos de aprendizaje.'], ['¿Sirve para cualquier país hispanohablante?', 'Sí. El material tiene un enfoque general y flexible que funciona en cualquier país de América Latina y para cualquier programa educativo.'], ['¿El material es editable?', 'Sí. Puedes adaptarlo a las necesidades de tu institución, tu grupo y tu programa.'], ['¿En qué moneda voy a pagar?', 'Pagas en tu moneda local. El importe se adapta automáticamente a tu país.'], ['¿Qué pasa si no me gusta?', 'Tienes 7 días de garantía total. Si el material no cumple tus expectativas, te devolvemos el 100% de tu dinero sin preguntas.']];
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-dark-card px-4 py-20" data-id="element-63">
      <div className="mx-auto max-w-3xl" data-id="element-64">
        <h2 className="mb-12 text-center font-serif text-4xl font-bold" data-id="element-65">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-66">
          {items.map(([question, answer], i) => <div key={question} className="overflow-hidden rounded-xl border border-dark-border bg-black" data-id="element-67">
              <button type="button" aria-expanded={open === i} onClick={() => setOpen(open === i ? -1 : i)} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold" data-id="element-68">
                <span data-id="element-69">{question}</span>
                <ChevronDown className={`shrink-0 text-gold transition-transform ${open === i ? 'rotate-180' : ''}`} data-id="element-70" />
              </button>

              <AnimatePresence initial={false} data-id="element-71">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} data-id="element-72">
                    <p className="border-t border-dark-border px-6 py-4 text-sm leading-relaxed text-gray-300" data-id="element-73">
                      {answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}